// extracted by mini-css-extract-plugin
export default {"circle":"ErrorCodesTooltip_circle__TQ+cA","rent":"ErrorCodesTooltip_rent__EKt8-","depo":"ErrorCodesTooltip_depo__HxTCX"};